import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Instagram, Linkedin, Twitter } from 'lucide-react';

const Footer = () => {
  const quickLinks = [
    { name: 'About Us', href: '/about' },
    { name: 'Our Fleet', href: '/vehicles' },
    { name: 'Contact', href: '/contact' },
    { name: 'Careers', href: '/careers' },
    { name: 'Terms & Conditions', href: '/terms' },
    { name: 'Privacy Policy', href: '/privacy' },
  ];

  const services = [
    'Airline Crew Logistics',
    'Hotel & Guest Transportation',
    'Corporate Shuttles',
    'Airport Operations',
    'Training Center Transfers',
    'Event Transportation'
  ];

  return (
    <footer className="bg-navy-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        
        {/* Main Footer Content */}
        <div className="py-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-12">

          {/* App Download - COMMENTED OUT - Links lead nowhere for now */}
          {/* <div className="lg:col-span-1">
            <h4 className="text-lg font-semibold mb-6 text-white">Crew & Client App</h4>
            <p className="text-navy-400 text-xs mb-6">Real-time tracking and communication for crews, guests, and clients.</p>
            <div className="space-y-3 max-w-[200px]">
              <a
                href="#"
                className="flex items-center px-3 py-2 bg-black rounded-lg hover:bg-gray-800 transition-all duration-200"
              >
                <svg className="w-5 h-5 mr-2 flex-shrink-0" viewBox="0 0 24 24" fill="white">
                  <path d="M17.05 20.28c-.98.95-2.05.8-3.08.35-1.09-.46-2.09-.48-3.24 0-1.44.62-2.2.44-3.06-.35C2.79 15.25 3.51 7.59 9.05 7.31c1.35.07 2.29.74 3.08.8 1.18-.24 2.31-.93 3.57-.84 1.51.12 2.65.72 3.4 1.8-3.12 1.87-2.38 5.98.48 7.13-.57 1.5-1.31 2.99-2.54 4.09l.01-.01zM12.03 7.25c-.15-2.23 1.66-4.07 3.74-4.25.29 2.58-2.34 4.5-3.74 4.25z"/>
                </svg>
                <div className="text-left min-w-0">
                  <div className="text-xs text-gray-400 leading-tight">Download on</div>
                  <div className="text-sm font-semibold text-white leading-tight">App Store</div>
                </div>
              </a>
              <a
                href="#"
                className="flex items-center px-3 py-2 bg-black rounded-lg hover:bg-gray-800 transition-all duration-200"
              >
                <svg className="w-5 h-5 mr-2 flex-shrink-0" viewBox="0 0 24 24" fill="white">
                  <path d="M3,20.5V3.5C3,2.91 3.34,2.39 3.84,2.15L13.69,12L3.84,21.85C3.34,21.6 3,21.09 3,20.5M16.81,15.12L6.05,21.34L14.54,12.85L16.81,15.12M20.16,10.81C20.5,11.08 20.75,11.5 20.75,12C20.75,12.5 20.53,12.9 20.18,13.18L17.89,14.5L15.39,12L17.89,9.5L20.16,10.81M6.05,2.66L16.81,8.88L14.54,11.15L6.05,2.66Z"/>
                </svg>
                <div className="text-left min-w-0">
                  <div className="text-xs text-gray-400 leading-tight">Get it on</div>
                  <div className="text-sm font-semibold text-white leading-tight">Google Play</div>
                </div>
              </a>
            </div>
          </div> */}

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-6 text-white">Quick Links</h4>
            <ul className="space-y-3">
              {quickLinks.map((link, index) => (
                <li key={index}>
                  <Link
                    to={link.href}
                    className="text-navy-300 hover:text-primary-400 transition-colors duration-200 text-sm"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-lg font-semibold mb-6 text-white">Our Services</h4>
            <ul className="space-y-3">
              {services.map((service, index) => (
                <li key={index} className="text-navy-300 text-sm">
                  {service}
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-semibold mb-6 text-white">Get In Touch</h4>
            <div className="space-y-3">
              <div className="flex items-start space-x-3">
                <MapPin className="w-5 h-5 text-primary-400 mt-1 flex-shrink-0" />
                <div>
                  <p className="text-navy-300 text-sm leading-relaxed">
                    Irving, TX 75039
                  </p>
                  <p className="text-navy-400 text-xs mt-1">
                    We serve Dallas - Fort Worth metroplex
                  </p>
                </div>
              </div>

              <div className="flex items-start space-x-3">
                <Phone className="w-5 h-5 text-primary-400 mt-1 flex-shrink-0" />
                <div>
                  <a
                    href="tel:+14695632674"
                    className="text-navy-300 hover:text-primary-400 transition-colors duration-200 text-sm block"
                  >
                    (469) 563-2674
                  </a>
                  <p className="text-xs text-navy-400 mt-0.5">Available 24/7</p>
                </div>
              </div>

              <div className="flex items-start space-x-3">
                <Mail className="w-5 h-5 text-primary-400 mt-1 flex-shrink-0" />
                <div>
                  <a
                    href="mailto:support@intimelog.com"
                    className="text-navy-300 hover:text-primary-400 transition-colors duration-200 text-sm block"
                  >
                    support@intimelog.com
                  </a>
                  <p className="text-xs text-navy-400 mt-0.5">Response within 1 hour</p>
                </div>
              </div>
            </div>

          </div>
        </div>

        {/* Bottom Footer */}
        <div className="py-6 border-t border-navy-800">
          <div className="flex flex-col md:flex-row justify-between items-center gap-6">
            {/* Left: Brand & Copyright */}
            <div className="text-center md:text-left">
              <p className="text-navy-300 text-sm font-semibold mb-2">
                InTimelog is a professional airline crew transportation company based in Dallas, Texas
              </p>
              <p className="text-navy-300 text-sm">
                © 2026 InTimelog. All rights reserved.
              </p>
              <p className="text-navy-400 text-xs mt-1">
                Licensed transportation provider • Dallas-Fort Worth Area
              </p>
            </div>

            {/* Center: Social Media */}
            <div className="flex items-center gap-5">
              <a
                href="https://www.instagram.com/intimelog_us"
                target="_blank"
                rel="noopener noreferrer"
                className="text-navy-300 hover:text-primary-400 transition-colors duration-200"
                aria-label="Follow us on Instagram"
              >
                <Instagram className="w-6 h-6" />
              </a>
              <a
                href="https://www.linkedin.com/company/intimelog"
                target="_blank"
                rel="noopener noreferrer"
                className="text-navy-300 hover:text-primary-400 transition-colors duration-200"
                aria-label="Follow us on LinkedIn"
              >
                <Linkedin className="w-6 h-6" />
              </a>
              <a
                href="https://twitter.com/intimelog"
                target="_blank"
                rel="noopener noreferrer"
                className="text-navy-300 hover:text-primary-400 transition-colors duration-200"
                aria-label="Follow us on Twitter"
              >
                <Twitter className="w-6 h-6" />
              </a>
            </div>

            {/* Right: Certifications */}
            <div className="flex items-center gap-6">
              <div className="flex items-center gap-2">
                <div className="w-2 h-2 bg-green-500 rounded-full"></div>
                <span className="text-navy-300 text-sm">DOT Certified</span>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-2 h-2 bg-primary-400 rounded-full"></div>
                <span className="text-navy-300 text-sm">Fully Insured</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;